import React, { useContext } from 'react';
import './ProjectList.css';
import projects from '../../data';
import Proj from '../Proj/Proj';
import { ThemeContext } from '../../context';

const ProjectList = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;
    return (
        <div  data-aos="fade-up"
        data-aos-duration="3000" className='pl'>
           <div className="pl-texts">
                <h1 className="pl-title"><span style={{color:darkMode ? "gray" : 'rgb(1, 57, 61)'}}>T</span>hese are my projects</h1>
                <p className="pl-desc">
                My projects are usually done with <span style={{color:darkMode ? "gray" : 'rgb(1, 57, 61)', fontWeight:"bold"}}>HTML, CSS, JavaScript, React, Bootstrap, Tailwind, MongoDB, Node-js, Material-UI, Firebase</span> for authentication etc technology.
                </p>
           </div>
           <div className="pl-lists">
               {
                   projects.map((item) =>(
                    <Proj  key={item.id} img={item.img} link={item.link} name={item.name} github={item.github} description={item.description} />
                   ))
               }
           </div>
        </div>
    );
};

export default ProjectList;